import { selector } from '@poa/state';
import { filteredData } from './gifts.selectors';

const columns = [
  {
    name: 'id',
    label: 'ID',
    width: 75,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'sender',
    label: 'Sender',
    width: 75,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'recipient',
    label: 'Recipient',
    width: 75,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'date',
    label: 'Date',
    width: 100,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'total',
    label: 'Total',
    width: 75,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'more',
    label: 'More',
    width: 75,
    sectionId: 'section_1',
    isSelected: true
  }
];

export const giftsInitialState = {
  gifts: {
    data: [],
    meta: {
      isLoading: false,
      hasError: false,
      loaded: false,
      onPage: 0,
      page: 1,
      pageSize: 50,
      pages: 0
    },
    filters: {
      grouping: {
        selected: null,
        options: []
      },
      columnSettings: {
        currentPresetId: 0,
        availablePresets: [
          {
            id: 0,
            label: 'по умолчанию',
            columnsConfiguration: columns
          }
        ],
        lastSelectedPresetColumns: []
      },
      filter: 'all'
    },
    selectors: {
      filteredData,
      selectedPreset: selector(store => store.gifts.filters.columnSettings.availablePresets[0])
    }
  }
};
